import MessageProcessor from './MessageProcessor.js';
import {AbstractParameter} from "parameters/AbstractParameter.js";

export default class Message extends MessageProcessor {
    constructor(track) {
        super("Message", track);

        this.newInlet(1);
        this.newOutlet("output");
        
        this.messageTextParameter = new AbstractParameter(
            "messageText", this, () => 0, {
                defaultValue: ""
            });
        this.registerParameter(this.messageTextParameter);

        // the last constructed message sennt
        this._messageText = undefined;
    }

    get messageText() {
        return this.messageTextParameter.get();
    }

    set messageText(x) {
        this.messageTextParameter.set(x, false);
    }

    processMessages() {
        // go thru the queued messages and construct the message text
        for (let type in this.queuedMessages) {
            // check if type exists in the messageText
            let msgs = this.queuedMessages[type][0];
            let text = this.messageText.replaceAll("$" + type, msgs[0]);
            this.sendMessage("output", text);
            this._messageText = text;
        }
        this.clearMessages();
    }

    // user action clicks the box
    execute() {
        this.sendMessage("output", this._messageText || this.messageText);
    }
}
